SCHEMA_UPDATE_PAYMENT_METHOD